var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcBatteryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.8,
    height: 19.5,
    viewBox: "0 0 25.8 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9,1.3C8.9,0.6,8.3,0,7.6,0H5C4.3,0,3.7,0.6,3.7,1.3v1.3h5.2V1.3z M21.9,1.3c0-0.7-0.6-1.3-1.3-1.3H18 c-0.7,0-1.3,0.6-1.3,1.3v1.3h5.2V1.3z M24.5,3.9H1.3C0.6,3.9,0,4.5,0,5.2v13c0,0.7,0.6,1.3,1.3,1.3h23.2c0.7,0,1.3-0.6,1.3-1.3v-13 C25.8,4.5,25.2,3.9,24.5,3.9z M16.1,11.2l-3.3,5.4c-0.4,0.6-1.4,0.3-1.3-0.4l0.2-3.2c0-0.1-0.1-0.2-0.2-0.2h-1.3 c-0.6,0-0.9-0.6-0.6-1.1L13,6.3c0.4-0.6,1.4-0.3,1.3,0.4L14.1,10c0,0.1,0.1,0.2,0.2,0.2h1.3C16.1,10.1,16.4,10.7,16.1,11.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcBatteryIcon);
export default __webpack_public_path__ + "static/media/ac-battery-icon.6b349c294a9cc9b7b3e28d8f453407a0.svg";
export { ForwardRef as ReactComponent };